import mimeDb from 'mime-db/db.json'

export function extension(mime: string): string | undefined {
  const result = (
    mimeDb as Record<string, { extensions?: string[] } | undefined>
  )[mime]
  return result?.extensions?.[0]
}
